<template>
  <general-item format="minislide">
    <span slot="title">{{ $t('edit.sidebar.in_mini_slider') }}</span>
    <span slot="description">{{ $t('edit.sidebar.one_small_window_apper') }}</span>
  </general-item>
</template>

<script>
import GeneralItem from './GeneralItem';

export default {
  components: {
    GeneralItem,
  },
};
</script>



/** WEBPACK FOOTER **
 ** MiniSlide.vue?2920cd76
 **/